module.exports = __webpack_public_path__ + "static/media/24.d599db86.png";